<!--
 * @Author: zyy
 * @Date: 2022-07-26 10:46:17
 * @LastEditors: zyy
 * @LastEditTime: 2022-12-19 12:18:50
 * @Description: 读卡器，房屋树
-->
<template>
  <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
    <a-card :bordered="false">
      <div id="page">
        <center>
          <h2 class="title2" style="">读卡器</h2>
        </center>

        <div class="sreen">
          <span class="code">未连接</span>
          <div class="icons">
            <i class="glyphicon glyphicon-resize-small c1 off"></i>
            <i class="glyphicon glyphicon-exclamation-sign c2 on"></i>
          </div>
        </div>

        <form class="form-horizontal">
          <div class="form-group">
            <label class="col-sm-2">串口设备：</label>
            <div class="col-sm-10">
              <span class="dev_desc">...</span>
            </div>
          </div>
        </form>
      </div>
      <div style="margin: 0 auto; width: 700px">
        <a-form-model
          class="app-form"
          style="margin-top: 50px"
          ref="form"
          :model="form"
          :rules="rules"
          :labelCol="$formLabelCol"
          :wrapperCol="$formWrapperCol"
        >
          <a-form-model-item label="所属房屋" prop="house">
            <div>
              <a-button type="primary" @click="showModal">选择</a-button>
            </div>
            <div>
              <a-tag
                class="large"
                closable
                @close.prevent="delHouse(index)"
                v-for="(value, index) in form.house"
                :key="index"
                >{{ value.full_name }}</a-tag
              >
            </div>
          </a-form-model-item>
          <a-form-model-item label="卡号" prop="car_no">
            <div>
              <a-input v-model="form.car_no" style="width: 200px"></a-input>
            </div>
          </a-form-model-item>
          <a-form-model-item label="有效期" prop="time">
            <a-range-picker v-model="form.time" show-time valueFormat="YYYY-MM-DD HH:mm:ss"></a-range-picker>
          </a-form-model-item>
        </a-form-model>
        <a-row style="margin: 40px 0">
          <a-col style="text-align: center">
            <a-button type="primary" style="width: 100px" @click="submit"
              >提交</a-button
            >
          </a-col>
        </a-row>
      </div>
    </a-card>
    <a-modal
      :title="modal.title"
      v-model="modal.show"
      @ok="confirmModal"
      destroy-on-close
      width="60%"
      centered
    >
      <tree-select
        v-model="modal.house"
        :data="tree.data"
        :params="tree.params"
        :load-data="$houseTreeData"
        @load="loadTreeSelectNode"
      ></tree-select>
    </a-modal>
  </div>
</template>

<script>
import "@/assets/js/jquery-1.9.1.min.js";
import GuardService from "@/io/guard.js";
export default {
  name: "CardReader",
  data() {
    return {
      tree: {
        data: [],
        params: {
          children: "children",
          title: "name",
          key: "_id",
        },
      },
      rules: {
        house: [
          {
            required: true,
            message: "请选择房屋",
          },
        ],
        car_no: [
          {
            required: true,
            message: "请填写卡号",
          },
        ],
        time: [
          {
            required: true,
            message: "请选择日期",
          },
        ],
      },
      form: {
        house: [],
        car_no: null,
        time:[]
      },
      modal: {
        title: "选择房屋",
        show: false,
        house: [],
      },
    };
  },
  mounted() {
    this.init();
    this.initTreeData();
  },
  methods: {
    // 提交
    submit() {
      this.$refs.form.validate((value) => {
        if (value) {
            GuardService.syncCard({
              car_no: this.form.car_no,
              house_id: this.form.house[0].id,
              start_time:this.form.time[0],
              end_time:this.form.time[1],
            }).then(_ => this.$message.success('开卡成功'));
          } 
      });
    },
    showModal() {
      this.modal.show = true;
      console.log(this.form.house);

      this.modal.house = this.$createNewVariable(this.form.house);
    },
    delHouse(index) {
      this.form.house.splice(index, 1);
    },
    loadTreeSelectNode(data) {
      data.children.forEach((val) => {
        this.$set(val, "disabled", val.level <= 3);
      });
    },
    confirmModal() {
      this.modal.show = false;
      this.form.house = this.$createNewVariable(this.modal.house);
    },
    // 树数据
    initTreeData() {
      return this.$houseTreeData([], [this.isPlatformRole ? 0 : 1, 4]).then(
        (res) => {
          this.tree.data = res.map((val) => {
            val.disabled = true;
            return val;
          });
        }
      );
    },
    // socket获取卡号,cv
    init() {
      let wsUri = "ws://127.0.0.1:10090/";
      let websocket = (window._websocket = new WebSocket(wsUri));

      let app = {
        //设置连接成功或失败是的界面
        ws_rf_query: function (data) {
          $("div.sreen .icons i").removeClass("on").addClass("off");
          if (data.result.status) {
            $("div.sreen .icons i.c1").removeClass("off").addClass("on");
            $("div.sreen .code").html("连接成功");
            $("button.conn_btn").attr("disabled", true);
            $("span.dev_desc").html(data.result.desc);
          } else {
            $("div.sreen .icons i.c2").removeClass("off").addClass("on");
            $("div.sreen .code").html("未发现设备");
            $("button.conn_btn").attr("disabled", false);
            $("span.dev_desc").html("");
          }
        },
      };
      websocket.onopen = function (evt) {
        console.info(evt);

        //查询读卡器状态
        websocket.send(JSON.stringify({ method: "ws_rf_query" }));
        //设置读卡器模式，auth: 0-不加密 1-加密模式  bytes：3-3字节模式 其他-全数据模式
        websocket.send(
          JSON.stringify({ method: "ws_rf_setup", auth: 1, bytes: 3 })
        );
      };

      websocket.onclose = function (evt) {
        console.info(evt);
      };

      websocket.onmessage = function (evt) {
        console.info(evt);

        var data = JSON.parse(evt.data);
        if ("method" in data) {
          $(document).trigger("/method/" + data.method, data);
        } else if ("event" in data) {
          $(document).trigger("/event/" + data.event, data);
        }
      };

      websocket.onerror = function (evt) {
        console.info(evt);
      };
      let that = this;
      $(document).bind("/event/ws_card", (evt, data) => {
        let s = data.data;
        if (data.permit == -2) {
          s += " 加密失败";
        } else if (data.permit == -3) {
          s += " 卡被复制";
        }
        if (data.permit != -2 && data.permit != -3)
          that.form.car_no = data.data;
        $("div.sreen>.code").html(s);
      });

      $(document).bind("/method/ws_rf_query", function (evt, data) {
        app.ws_rf_query(data);
      });
    },
  },
};
</script>





<style scoped lang="less">
html,
body {
  background-color: #5e5e5e;
  padding: 0;
  margin: 0;
}
#page {
  margin: 1em auto;
  max-width: 700px;
}

#page .title2 {
  font-weight: bold;
  color: #e89023;
  display: inline;
  margin: 0;
  padding: 0;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
}

#page form {
  padding: 1em;
  border: 1px solid #c0c0c0;
  border-radius: 4px;
  margin-bottom: 0em;
  background-color: #ffffff;
}

#page .sreen {
  min-height: 50px;
  line-height: 50px;
  background-color: #0f0f0f;
  padding: 0.4em;
  margin: 10px 0 8px 0;
  border-radius: 4px;
  font-size: 32px;
  color: #fff;
  position: relative;
}

#page .sreen .code {
  word-spacing: 16px;
  letter-spacing: 4px;
  text-align: center;
  display: block;
}

#page .sreen .icons {
  font-size: 24px;
  position: absolute;
  left: 20px;
  bottom: 24px;
}

#page .sreen .icons .c1.on {
  color: greenyellow;
}
#page .sreen .icons .c1.off {
  color: #444444;
}

#page .sreen .icons .c2.on {
  color: red;
}
#page .sreen .icons .c2.off {
  color: #444444;
}
</style>